module.exports = __webpack_public_path__ + "static/img/第二十四届.e6c7761.png";


//////////////////
// WEBPACK FOOTER
// ./static/20260620/past/第二十四届.png
// module id = brVP
// module chunks = 1